import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, FormLabel, Tooltip, Button as MuiButton } from '@mui/material';
import { SplitButton } from './SplitButton';
import styled from 'styled-components';

const WIP_FILTERS = ['My peers'];

export const ButtonOptions = ({
  title,
  titleMarging = 10,
  options,
  onChange,
  float,
  value,
  optionsObject,
  otherHelpText,
  multiple,
  optionsTextHelper,
  customStyle
}) => {
  const handleOnClick = option => {
    onChange(option);
  };
  const handleOnSelect = option => {
    if (multiple) {
      let newValue = value;
      const included = value.includes(option);
      if (included) {
        newValue = newValue.replace(option, '');
        newValue = newValue.replace(',,', ',');
      } else {
        newValue += `,${option}`;
      }
      newValue = newValue.replace(/(^[,\s]+)|([,\s]+$)/g, '');
      onChange(newValue);
    } else {
      onChange(option);
    }
  };

  const getButton = (option) => {
    const isDisabled = WIP_FILTERS.indexOf(option) > -1;
    const styles = (isDisabled) ? { fontSize: 11, color: '#ccc', borderColor: '#ccc'} : { fontSize: 11 };
    const button = (
      <Tooltip title={optionsTextHelper(option)} placement="top">
        <Button
          key={option}
          onClick={() => !isDisabled && handleOnClick(option)}
          variant={option === value ? 'contained' : 'outlined'}
          selected={option === value}
          style={styles}
        >
          {option}
        </Button>
      </Tooltip>
    );
    if (!isDisabled) {
      return button;
    }
    return (
      <Tooltip title="Coming Soon">
        { button }
      </Tooltip>
    );
  };

  return (
    <Field style={customStyle || { float: float ? 'left' : 'none', width: '100%' }}>
      {title !== undefined && (
        <FormLabel style={{ marginRight: titleMarging }}>{title}</FormLabel>
      )}
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        {options.map(option => getButton(option))}
        {optionsObject !== undefined && (
          <SplitButton
            options={optionsObject}
            onSelect={handleOnSelect}
            value={value}
            multiple={multiple}
            tooltipText={otherHelpText}
          />
        )}
      </ButtonGroup>
    </Field>
  );
};

ButtonOptions.propTypes = {
  title: PropTypes.string,
  titleMarging: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  float: PropTypes.bool,
  value: PropTypes.string,
  optionsObject: PropTypes.array,
  otherHelpText: PropTypes.string,
  multiple: PropTypes.bool,
};

export const Field = styled.div`
  width: '100%';
`;

export const Button = styled(MuiButton)`
  color: ${props => (props.selected ? 'white !important' : 'inherit')};
  font-size: 10px;
  text-transform: none !important;
`;
